import React from 'react';

import { SurveyDataManagerApiError } from 'domain/surveyDataManager/contracts/common';

import './InlineErrorBanner.scss';

export interface InlineErrorBannerProps {
  readonly title: string;
  readonly error: SurveyDataManagerApiError;
  onRetry?: () => void;
}

function InlineErrorBanner({
  title,
  error,
  onRetry,
}: InlineErrorBannerProps): JSX.Element {
  return (
    <div role="alert" className="sdm-error-banner">
      <div>
        <p className="sdm-error-banner__title">{title}</p>
        <p className="sdm-error-banner__message">
          {error.message}
          {error.code ? ` (${error.code})` : ''}
        </p>
      </div>
      {onRetry ? (
        <button type="button" className="sdm-error-banner__retry" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

export default InlineErrorBanner;
